export const OrgReportedEventsTestIds = {
  filterRow: 'filter_row',
  filterLabel: 'filter_label',
  filterControls: 'filter_controls',
  filterSelection: 'filter_selection',
  userIdOption: 'user_id_option',
  tableSettingsComponent: 'table_settings_component',
  reportedmessageEventid: 'reportedmessage_eventid',
  reportedmessageBody: 'reportedmessage_body',
  reportSearch: 'report_search',
  deleteButton: 'delete_button',
  reportedmessageReason: 'reportedmessage_reason'
} as const;
